import React, { useState, useEffect, useCallback } from "react";
import { Modal, Button } from "react-bootstrap";
import { createModal } from "react-modal-promise";
import locationImg from "../../../images/location_pin.png";

var map_depart, map_loadarea, map_image1, map_image2;
var marker_depart, marker_loadarea, marker_image1, marker_image2;
var popup_depart, popup_loadarea, popup_image1, popup_image2;

const DepartureReportPop = (props) => {
  const [show, setShow] = useState(true);
  const { Tmapv2 } = window;

  //코드 및 그리드 초기화 및 생성
  useEffect(() => {
    const initMap = () => {
      map_depart = new window.Tmapv2.Map("map_depart", {
        center: new window.Tmapv2.LatLng(props.dprtLatt, props.dprtLont), // 지도 초기 좌표
        // width: "100%",
        height: "300px",
        zoom: 17,
      });

      marker_depart = new Tmapv2.Marker({
        position: new Tmapv2.LatLng(props.dprtLatt, props.dprtLont),
        map: map_depart,
      });

      popup_depart = new Tmapv2.InfoWindow({
        position: new Tmapv2.LatLng(props.dprtLatt, props.dprtLont), //Popup 이 표출될 맵 좌표
        type: 2,
        map: map_depart, // 지도 객체
      });
      map_loadarea = new window.Tmapv2.Map("map_loadarea", {
        center: new window.Tmapv2.LatLng(props.loadLatt, props.loadLont), // 지도 초기 좌표
        // width: "100%",
        height: "300px",
        zoom: 17,
      });

      marker_loadarea = new Tmapv2.Marker({
        position: new Tmapv2.LatLng(props.loadLatt, props.loadLont),
        map: map_loadarea,
      });

      popup_loadarea = new Tmapv2.InfoWindow({
        position: new Tmapv2.LatLng(props.loadLatt, props.loadLont), //Popup 이 표출될 맵 좌표
        type: 2,
        map: map_loadarea, // 지도 객체
      });
      map_image1 = new window.Tmapv2.Map("map_image1", {
        center: new window.Tmapv2.LatLng(
          props.dprtVhcl01Latt,
          props.dprtVhcl01Lont
        ), // 지도 초기 좌표
        // width: "100%",
        height: "300px",
        zoom: 17,
      });

      marker_image1 = new Tmapv2.Marker({
        position: new Tmapv2.LatLng(props.dprtVhcl01Latt, props.dprtVhcl01Lont),
        map: map_image1,
      });

      popup_image1 = new Tmapv2.InfoWindow({
        position: new Tmapv2.LatLng(props.dprtVhcl01Latt, props.dprtVhcl01Lont), //Popup 이 표출될 맵 좌표
        type: 2,
        map: map_image1, // 지도 객체
      });

      map_image2 = new window.Tmapv2.Map("map_image2", {
        center: new window.Tmapv2.LatLng(
          props.dprtVhcl02Latt,
          props.dprtVhcl02Lont
        ), // 지도 초기 좌표
        // width: "100%",
        height: "300px",
        zoom: 17,
      });

      marker_image2 = new Tmapv2.Marker({
        position: new Tmapv2.LatLng(props.dprtVhcl02Latt, props.dprtVhcl02Lont),
        map: map_image2,
      });

      popup_image2 = new Tmapv2.InfoWindow({
        position: new Tmapv2.LatLng(props.dprtVhcl02Latt, props.dprtVhcl02Lont), //Popup 이 표출될 맵 좌표
        type: 2,
        map: map_image2, // 지도 객체
      });
    };

    initMap();
  }, []);
  const handleClose = (returnData) => {
    setShow(false);
  };

  const handleOk = (returnData) => {
    setShow(false);
  };

  return (
    <>
      <Modal show={show} onHide={() => handleClose(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>출발보고 위치</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="t_garo">
            <tr>
              <th
                style={{
                  textAlign: "center",
                  padding: "0",
                }}
              >
                <img src={locationImg} style={{ verticalAlign: "middle" }} />
                출발보고위치
              </th>
              <th
                style={{
                  textAlign: "center",
                  padding: "0",
                }}
              >
                <img src={locationImg} style={{ verticalAlign: "middle" }} />
                상차지위치
              </th>
            </tr>
            <tr>
              <td
                style={{ padding: "0", width: "50%", border: "1px solid #000" }}
              >
                <div id="map_depart" style={{ height: "100%" }}></div>
              </td>
              <td
                style={{ padding: "0", width: "50%", border: "1px solid #000" }}
              >
                <div id="map_loadarea" style={{ height: "100%" }}></div>
              </td>
            </tr>
            <tr>
              <th
                style={{
                  textAlign: "center",
                  padding: "0",
                }}
              >
                <img src={locationImg} style={{ verticalAlign: "middle" }} />
                사진1위치
              </th>
              <th
                style={{
                  textAlign: "center",
                  padding: "0",
                }}
              >
                <img src={locationImg} style={{ verticalAlign: "middle" }} />
                사진2위치
              </th>
            </tr>
            <tr>
              <td
                style={{ padding: "0", width: "50%", border: "1px solid #000" }}
              >
                <div id="map_image1" style={{ height: "100%" }}></div>
              </td>
              <td
                style={{ padding: "0", width: "50%", border: "1px solid #000" }}
              >
                <div id="map_image2" style={{ height: "100%" }}></div>
              </td>
            </tr>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => handleOk(true)}>
            확인
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export const ModalDepartureReportPop = createModal(DepartureReportPop);

export default DepartureReportPop;
